/* global axios */
import ApiClient from '../ApiClient';

// MODO ASSISTIDO — aprovar ou descartar a sugestão da Andie. O id é o da nota
// privada que carrega a sugestão. Ver SugestoesController.
class SugestoesAPI extends ApiClient {
  constructor() {
    super('captain/sugestoes', { accountScoped: true });
  }

  enviar(id, texto) {
    return axios.post(`${this.url}/${id}/enviar`, { texto });
  }

  descartar(id) {
    return axios.post(`${this.url}/${id}/descartar`);
  }
}

export default new SugestoesAPI();
